<template>
  <!-- WI 2205: skrivebeskyttet visning for server-tildelte felt (f.eks. Løpenummer).
       Ingen redigerbar input — verdien settes server-side. -->
  <div class="p-2 italic text-fg-muted" :class="{ 'not-italic': hasValue }">
    {{ displayValue }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean, Array, Date, Object],
    default: null
  },
  header: { type: Object, default: () => ({}) },
  // US 3399: id deklareres, men videreformidles BEVISST ikke - denne komponenten rendrer ingen
  // labelable kontroll aa peke paa. Deklarasjonen finnes for aa STOPPE Vues attribute-fallthrough:
  // uten den ville en id havnet paa rot-diven, og en <label for=> dit ville tilfredsstilt statisk
  // analyse mens HTMLLabelElement.control fortsatt var null. Se editComponentAcceptsId.
  id: { type: String, default: undefined }
})

const hasValue = computed(() =>
  props.modelValue !== null && props.modelValue !== undefined && props.modelValue !== ''
)

const displayValue = computed(() => (hasValue.value ? String(props.modelValue) : '(auto)'))
</script>
